/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';

import AssetChangeRequestPage from '../pages/AssetChangeRequestPage';

export default async function ShowAssetChangeRequest(assets) {
  NProgress.start();
  try {
    NavUtils.navigate(`inventory/asset-change-request`);
    Scaffold.getRegion('content').show(
      new AssetChangeRequestPage({
        model: new Backbone.Model({
            assets
        })
      })
    );
  } finally {
    NProgress.done();
  }
}
